import conversations from './conversations'

export default conversations
